const headlesss_config = {
  url: 'https://headless.freundbild.xyz',
  project: '_',
  email: 'rene@freundbild.com',
  password: 'freundRene#16'
};

export default headlesss_config;